const watchFor = <T extends HTMLElement>(
  containerEl: HTMLElement,
  tagName: string,
  onChange: (el: T | undefined) => void,
  changeHandler: (MutationRecord, string) => any,
  options: MutationObserverInit = {
    childList: true,
    subtree: true,
  }
) => {
  let mutation
  if (typeof MutationObserver !== "undefined") {
    mutation = new MutationObserver(mutationList => {
      onChange(changeHandler(mutationList, tagName))
    })
    mutation.observe(containerEl, options)
  }
  return mutation
}

export const watchForOptions = <T extends HTMLElement>(
  containerEl: HTMLElement,
  tagName: string,
  onChange: (el: T | undefined) => void
) => {
  return watchFor(containerEl, tagName, onChange, getSelectedOption)
}

export const watchForElement = <T extends HTMLElement>(
  containerEl: HTMLElement,
  tagName: string,
  onChange: (el: T | undefined) => void
) => {
  return watchFor(containerEl, tagName, onChange, getElementItem, {
    childList: true,
    subtree: true,
  })
}

const getElementItem = (mutationList: MutationRecord[]): Record<string, any> => {
  let addedNode = false
  let removedNode = false
  mutationList.forEach(mut => {
    if (mut.addedNodes.length) {
      addedNode = true
    }
    if (mut.removedNodes.length) {
      removedNode = true
    }
  })
  return { addedNode, removedNode, mutationList }
}

const getSelectedOption = <T extends HTMLElement>(mutationList: MutationRecord[], tagName: string): T | undefined => {
  let newOption: HTMLElement | undefined
  mutationList.forEach(mut => {
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < mut.addedNodes.length; i++) {
      newOption = findCheckedOption(mut.addedNodes[i], tagName) || newOption
    }
  })
  return newOption as any
}

export const findCheckedOption = (el: any, tagName: string) => {
  if (el.nodeType !== 1) {
    return undefined
  }
  const options: HTMLElement[] = el.tagName === tagName.toUpperCase() ? [el] : Array.from(el.querySelectorAll(tagName))

  return options.find((o: any) => o.checked === true)
}

export const findErrorItems = (el: any, tagName: string) => {
  if (el.nodeType !== 1) {
    return undefined
  }
  const options: HTMLElement[] = el.tagName === tagName.toUpperCase() ? [el] : Array.from(el.querySelectorAll(tagName))

  return options.find((o: any) => o.checked === true)
}
